import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";

function DanzaAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="" style={{fontFamily: "Hammersmith One"}}></th>
                                    <th scope="col" style={{width: "30%"}}>
                                        3 mesi
                                    </th>
                                    <th scope="col" style={{width: "30%"}}>
                                        6 mesi
                                    </th>
                                    <th scope="col" style={{width: "30%"}}>
                                        Stagionale
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td></td>
                                    <th colSpan={3}  scope="" style={{fontFamily: "Hammersmith One"}}>Corsi da 60 minuti</th>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Monosettimanale</th>
                                    <td className={"data-cell"}>144€</td>
                                    <td className={"data-cell"}>264€</td>
                                    <td className={"data-cell"}>370€</td>
                                </tr>
                                <tr>
                                    <th scope="row">Bisettimanale</th>
                                    <td className={"data-cell"}>216€</td>
                                    <td className={"data-cell"}>360€</td>
                                    <td className={"data-cell"}>555€</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <th colSpan={3}  scope="" style={{fontFamily: "Hammersmith One"}}>Corsi da 90 minuti</th>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Monosettimanale</th>
                                    <td className={"data-cell"}>276€</td>
                                    <td className={"data-cell"}>432€</td>
                                    <td className={"data-cell"}>666€</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <table className="table text-center m-auto" style={{maxWidth: "30em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" ></th>
                                    <th scope="col" style={{width: "75%"}}>
                                        Stagionale
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}></tr>
                                    <th scope="row" style={{width: "50%"}}>
                                        Pacchetto Experience
                                        <br/> <span style={{fontSize: "14px"}}>(OPEN - tutti i corsi)</span>
                                    </th>
                                <td>780€</td>
                                </tbody>
                            </table>
                            <br/>
                            <AllertIscrizione />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DanzaAccordionPrezzi